import { Button, Dropdown } from "antd";
import React, { useState } from "react";
import { GoPlusCircle } from "react-icons/go";
import { IoFilterCircleOutline } from "react-icons/io5";
import { PiHamburger } from "react-icons/pi";
import { Link, useNavigate } from "react-router-dom";
import { IoDocumentTextOutline } from "react-icons/io5";
import { IoMdPerson } from "react-icons/io";
import { MdOutlineIncompleteCircle } from "react-icons/md";
import { MdOutlineCalculate } from "react-icons/md";
import Calculations from "./Calculations";
import { TbSmartHome } from "react-icons/tb";

export default function TicketsHeader({ title = "Tiketlar" }) {
  let navigate = useNavigate();
  let [open, setOpen] = useState(false);

  const items = [
    {
      key: "1",
      label: (
        <Link
          className=" block w-[100%] flex items-center justify-start gap-1"
          rel="noopener noreferrer"
          to="/tickets"
        >
          <IoDocumentTextOutline className="font-[30px]" /> Ticketlar
        </Link>
      ),
    },
    // {
    //   key: "2",
    //   label: (
    //     <Link
    //       className=" block w-[100%] flex items-center justify-start gap-1"
    //       rel="noopener noreferrer"
    //       to="/checkUser"
    //     >
    //       <GoPlusCircle className="font-[30px]" /> Ticket
    //     </Link>
    //   ),
    // },
    {
      key: "3",
      label: (
        <Link
          className=" block w-[100%] flex items-center justify-start gap-1"
          rel="noopener noreferrer"
          to="/customers"
        >
          <IoMdPerson /> Xaridorlar
        </Link>
      ),
    },
    {
      key: "4",
      label: (
        <Link
          className=" block w-[100%] flex items-center justify-start gap-1"
          rel="noopener noreferrer"
          to="/tickets/kirim"
        >
          <MdOutlineIncompleteCircle /> Kirimlar
        </Link>
      ),
    },
    // {
    //   key: "5",
    //   label: (
    //     <Link
    //       className=" block w-[100%] flex items-center justify-start gap-1"
    //       rel="noopener noreferrer"
    //       to="/yukxati/kirim/new"
    //     >
    //       <GoPlusCircle className="font-[30px]" /> kirim qo'shish
    //     </Link>
    //   ),
    // },
    {
      key: "6",
      label: (
        <div
          className=" block w-[100%] flex items-center justify-start gap-1"
          rel="noopener noreferrer"
          onClick={() => {
            setOpen(true);
          }}
        >
          <MdOutlineCalculate className="font-[30px]" /> Kalkulatsiya
        </div>
      ),
    },
    {
      key: "9",
      label: (
        <Link
          className=" block w-[100%] flex items-center justify-start gap-1"
          rel="noopener noreferrer"
          to="/"
        >
          <TbSmartHome className="font-[30px]" /> Bosh sahifa
        </Link>
      ),
    },
  ];

  return (
    <div className="max-w-[900px] m-auto w-[100%] flex  bg-[#fff] z-10 flex-row  items-center justify-between p-[10px]">
      <h2 className="bold text-[20px]">{title}</h2>
      <Calculations setOpen={setOpen} open={open} />
      <div className="flex gap-1">
        <Dropdown
          menu={{
            items,
          }}
          placement="topRight"
          arrow
        >
          <Button>
            <PiHamburger />
          </Button>
        </Dropdown>
      </div>
    </div>
  );
}
